/** 公司编码 */
export const companyTextMap = {
  1: '集团总部',
  2: '黄金珠宝板块',
  3: '智慧供应链板块',
  4: '产城发展板块',
  5: '产业投资板块',
};
